const logEvent = (action, category, label = undefined, value = undefined) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

export const logEventContactFormOpened = () => {
  logEvent('open', 'form', 'contact')
}

export const logEventContactFormSubmitted = () => {
  logEvent('submit', 'form', 'contact')
}

export const logEventVideoPlayed = () => {
  logEvent('play', 'video')
}
